import axios from 'axios'

const ENDPOINT = '/api/internal/generator/dcc-bridge/download-urls'

const csrfToken = () => {
  const meta = document.getElementsByName('csrf-token')[0]
  return meta?.getAttribute('content')
}

// BE returns one of:
//   200 { files: [{ url, filename }, ...], name, provider: 'meshy'|'tripo'|'tencent'|'cgt_converter' }
//   202 { status: 'pending' }   - fbx conversion still running; caller should poll
//   422                          - asset ineligible / provider unsupported
//
// Caller distinguishes by inspecting the `status` field.
export const requestDccExportPayload = async (assetId) => {
  const response = await axios.post(
    ENDPOINT,
    { asset_id: assetId },
    {
      headers: { 'X-CSRF-Token': csrfToken() },
      withCredentials: true,
      validateStatus: (status) => status === 200 || status === 202,
    },
  )

  if (response.status === 202) return { status: 'pending' }
  return {
    status: 'ready',
    files: response.data?.files,
    name: response.data?.name,
    provider: response.data?.provider,
  }
}
